import React from 'react';
import { useSelector } from 'react-redux';
import { isPreviewPlayerSelector } from '../../slices/chat/ChatSlice';
import {
  isEmbeddedPlayerSelector,
  isFullscreenSelector,
} from '../../slices/vh-player/VHPlayerSlice';
import { Button } from '@virtidev/toolbox';
import { useTranslation } from 'react-i18next';

const FinishSessionButton = ({ courseID }) => {
  const isPreviewPlayer = useSelector(isPreviewPlayerSelector);
  const isEmbeddedPlayer = useSelector(isEmbeddedPlayerSelector);
  const fullscreen = useSelector(isFullscreenSelector);
  const { t } = useTranslation();
  const backToText = courseID ? t('backToCourse') : t('backToVirtualHumans');

  if (isEmbeddedPlayer) return <></>;

  return (
    <Button
      onClick={() => {
        if (fullscreen) {
          document.exitFullscreen();
        }
        var event = new CustomEvent('onVHSessionCompleteAndUserContinued');
        window.parent.document.dispatchEvent(event);
      }}
      disabled={isPreviewPlayer}
      color="turquoise"
    >
      {backToText}
    </Button>
  );
};

export default FinishSessionButton;
